import formatMoney from "./format-money";

const globaleBtnsText = document.querySelectorAll('.js-currentCountryCurrency');
const globaleCountrySelect = document.querySelector('.js-globaleCountrySelect');
const moneyFormatWithoutCurrency = getMoneyFormatWithoutCurrency();
const currencySymbolFormatted = getCurrencySymbolFormatted();

const globaleInit = () => {
  setglobaleBtnText();
}

const setglobaleBtnText = () => {
  const country = globaleCountrySelect.dataset.countryCode;
  const symbol = globaleCountrySelect.dataset.currencySymbol;
  const currency = globaleCountrySelect.dataset.currencyCode;
  const selectedCurrency = symbol ? symbol : currency;
  globaleBtnsText.forEach(btn => btn.textContent = `${country}/${selectedCurrency}`);
}

function getMoneyFormatWithoutCurrency() {
  try {
    const moneyFormatting = JSON.parse(document.querySelector('#js-money-formatting').innerHTML);
    const moneyFormat = moneyFormatting.moneyFormat;
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatText = moneyFormat.match(placeholderRegex)[1];

    return `{{${formatText}}}`;
  } catch (e) {
    console.error("Error loading js-money-formatting: ", e);
    return '{{amount}}';
  }
}

function getCurrencySymbolFormatted() {
  if (globaleCountrySelect.dataset.countryCode == 'US') return '$';

  return globaleCountrySelect.dataset.currencyCode + ' ';
}

const getFormattedMoneyString = (amountInCents) => {
  const format = `${currencySymbolFormatted}${moneyFormatWithoutCurrency}`;

  return formatMoney(amountInCents, format);
}

const removeTrailingZeros = (priceString) => {
  const priceStringArray = Array.from(priceString);

  const lastIndex = priceStringArray.length - 1;
  const secondToLastIndex = priceStringArray.length - 2;
  const thirdToLastIndex = priceStringArray.length - 3;

  if (priceStringArray[thirdToLastIndex] != '.' && priceStringArray[thirdToLastIndex] != ',') {
    return priceString;
  }

  if (priceStringArray[lastIndex] == '0' && priceStringArray[secondToLastIndex] == '0') {
    let priceWithoutTrailingZeros = '';

    priceStringArray.forEach((char, index) => {
      if (index < thirdToLastIndex) {
        priceWithoutTrailingZeros += char;
      }
    });

    return priceWithoutTrailingZeros;
  }

  return priceString;
}

const getLocalURL = url => {
  if (!url) return window.Shopify.routes.root;

  let rootURL = window.Shopify.routes.root.slice(0, -1);
  return rootURL + url;
}

export {
  globaleInit,
  getFormattedMoneyString,
  removeTrailingZeros,
  getLocalURL
}
